import { render, staticRenderFns } from "./Dowload.vue?vue&type=template&id=59db9bba&scoped=true&"
import script from "./Dowload.vue?vue&type=script&lang=js&"
export * from "./Dowload.vue?vue&type=script&lang=js&"
import style0 from "./Dowload.vue?vue&type=style&index=0&id=59db9bba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db9bba",
  null
  
)

export default component.exports